module.exports = __webpack_public_path__ + "img/icon-info-ani.0bdde1d5.svg";